var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgFormsSettings = function SvgFormsSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.846 5.834a2.899 2.899 0 004.308 0l1.402-1.538a2.902 2.902 0 015.052 2.094l-.106 2.074a2.9 2.9 0 003.039 3.043l2.074-.106a2.903 2.903 0 012.089 5.052l-1.544 1.393a2.904 2.904 0 000 4.31l1.544 1.392A2.903 2.903 0 0133.61 28.6l-2.074-.105a2.9 2.9 0 00-3.046 3.046l.106 2.074a2.902 2.902 0 01-5.04 2.089L22.16 34.16a2.903 2.903 0 00-4.308 0l-1.4 1.543a2.902 2.902 0 01-5.045-2.086l.106-2.074a2.9 2.9 0 00-3.046-3.046l-2.074.105a2.9 2.9 0 01-2.098-5.048l1.543-1.392a2.904 2.904 0 000-4.31l-1.543-1.4a2.9 2.9 0 012.088-5.046l2.074.106a2.901 2.901 0 003.049-3.052l-.1-2.076a2.903 2.903 0 015.046-2.089l1.393 1.538z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 20.002a6.666 6.666 0 1013.333 0 6.666 6.666 0 00-13.333 0v0z",
    stroke: "#5F6771",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFormsSettings;